import { render, staticRenderFns } from "./ResistCustom.vue?vue&type=template&id=65f58860&scoped=true&"
import script from "./ResistCustom.vue?vue&type=script&lang=js&"
export * from "./ResistCustom.vue?vue&type=script&lang=js&"
import style0 from "./ResistCustom.vue?vue&type=style&index=0&id=65f58860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f58860",
  null
  
)

export default component.exports